'use client';

import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import type { ListItem } from '../list/item/list-item';

export interface RecommendationNagOptions {
  id: string;
  items: ListItem[];
  title?: string;
}

export type AddRecommendationNagOptions = Omit<RecommendationNagOptions, 'id'> & { id?: string };

export interface RecommendationNagState {
  recommendationNags: RecommendationNagOptions[];
  addRecommendationNag: (nag: AddRecommendationNagOptions) => void;
  removeRecommendationNag: (nagId: string) => void;
  resetRecommendationNags: VoidFunction;
}

export const useRecommendationNag = create<RecommendationNagState>((set) => ({
  recommendationNags: [],
  addRecommendationNag: (nag) => {
    set((state) => {
      const constructedNag = {
        ...nag,
        id: nag.id || Date.now().toString(),
      };

      if (!state.recommendationNags.find((n) => n.id === constructedNag.id)) {
        return { recommendationNags: [...state.recommendationNags, constructedNag] };
      }

      return state;
    });
  },
  removeRecommendationNag: (nagId) => {
    set((state) => ({ recommendationNags: state.recommendationNags.filter((n) => n.id !== nagId) }));
  },
  resetRecommendationNags: () => set({ recommendationNags: [] }),
}));

export function useAddRecommendationNag() {
  return useRecommendationNag(useShallow((state) => state.addRecommendationNag));
}

export function useResetRecommendationNags() {
  return useRecommendationNag(useShallow((state) => state.resetRecommendationNags));
}
